import UserDataDisplay from './UserDataDisplay'

export default UserDataDisplay
